import React from 'react';
import { APIs } from './APIs';
import { APIDoc } from './APIDoc';
import { Changes } from './Changes';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

export const App: React.FC = () => (
    <div className="App">
        <BrowserRouter>
            <Routes>
                <Route path="/apis" element={<APIs />} />
                <Route path="/changes" element={<Changes />} />
                <Route path="/" element={<APIs />} />
                <Route path="*" element={<APIs />} />
                <Route path="/documentation/:identifier/version/:apiVersion" element={<APIDoc />} />
                <Route path="/documentation/:identifier" element={<APIDoc />} />
            </Routes>
        </BrowserRouter>
    </div>
);
